export default {"src":"/_next/static/media/error-icon.659d461a.svg","height":48,"width":48};